import { CORE_FORM } from 'src/core/constants/crudFormsData'

export const ATTACHMENT_FORM_ID = CORE_FORM.attachments.id
export const FILE_FIELD_NAME = 'File'
export const ATTACHMENT_FORM_CODE = CORE_FORM.attachments.code
